export default {
  CLICKOUT: 1,
  ADPAGE_CLICKIN: 2, // the ad have internal_url, but no adpage_form
  ADPAGE_CLICKIN_FORM: 3, // the ad have internal_url, and adpage_form is set to true.
  ADPAGE_CLICKOUT: 4, // the ad have internal_url, and the flag fna (force no adpage) is set to true.
  EXPIRED: 5, // when there's a click in a non-existent ad
};



// WEBPACK FOOTER //
// ./app/tracking/ClickTypes.js